/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteRouteImport } from './routes/public/route'
import { Route as UnauthedRouteRouteImport } from './routes/_unauthed/route'
import { Route as AuthedRouteRouteImport } from './routes/_authed/route'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedChangePasswordRouteImport } from './routes/_authed/change-password'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as UnauthedAuthRouteRouteImport } from './routes/_unauthed/auth/route'
import { Route as AuthedWorkspacesRouteRouteImport } from './routes/_authed/workspaces/route'
import { Route as AuthedRelationshipsRouteRouteImport } from './routes/_authed/relationships/route'
import { Route as AuthedCartographiesRouteRouteImport } from './routes/_authed/cartographies/route'
import { Route as AuthedWorkspacesIndexRouteImport } from './routes/_authed/workspaces/index'
import { Route as AuthedCartographiesIndexRouteImport } from './routes/_authed/cartographies/index'
import { Route as PublicCartographiesIdRouteImport } from './routes/public/cartographies/$id'
import { Route as UnauthedAuthSignupRouteImport } from './routes/_unauthed/auth/signup'
import { Route as UnauthedAuthResetPasswordRouteImport } from './routes/_unauthed/auth/reset-password'
import { Route as UnauthedAuthResetRouteImport } from './routes/_unauthed/auth/reset'
import { Route as UnauthedAuthLoginRouteImport } from './routes/_unauthed/auth/login'
import { Route as AuthedRelationshipsSettingsRouteImport } from './routes/_authed/relationships/settings'
import { Route as AuthedRelationshipsDetailsRouteImport } from './routes/_authed/relationships/details'
import { Route as AuthedWorkspacesIdRouteRouteImport } from './routes/_authed/workspaces/$id/route'
import { Route as AuthedCartographiesIdRouteRouteImport } from './routes/_authed/cartographies/$id/route'
import { Route as AuthedWorkspacesIdIndexRouteImport } from './routes/_authed/workspaces/$id/index'
import { Route as AuthedCartographiesIdIndexRouteImport } from './routes/_authed/cartographies/$id/index'
import { Route as AuthedWorkspacesIdSharingRouteImport } from './routes/_authed/workspaces/$id/sharing'
import { Route as AuthedWorkspacesIdSettingsRouteImport } from './routes/_authed/workspaces/$id/settings'
import { Route as AuthedWorkspacesIdNodesRouteImport } from './routes/_authed/workspaces/$id/nodes'
import { Route as AuthedCartographiesIdClassicRouteImport } from './routes/_authed/cartographies/$id/classic'

const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/public',
  path: '/public',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthedRouteRoute = UnauthedRouteRouteImport.update({
  id: '/_unauthed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedChangePasswordRoute = AuthedChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const UnauthedAuthRouteRoute = UnauthedAuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => UnauthedRouteRoute,
} as any)
const AuthedWorkspacesRouteRoute = AuthedWorkspacesRouteRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedRelationshipsRouteRoute =
  AuthedRelationshipsRouteRouteImport.update({
    id: '/relationships',
    path: '/relationships',
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedCartographiesRouteRoute =
  AuthedCartographiesRouteRouteImport.update({
    id: '/cartographies',
    path: '/cartographies',
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspacesIndexRoute = AuthedWorkspacesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedWorkspacesRouteRoute,
} as any)
const AuthedCartographiesIndexRoute =
  AuthedCartographiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedCartographiesRouteRoute,
  } as any)
const PublicCartographiesIdRoute = PublicCartographiesIdRouteImport.update({
  id: '/cartographies/$id',
  path: '/cartographies/$id',
  getParentRoute: () => PublicRouteRoute,
} as any)
const UnauthedAuthSignupRoute = UnauthedAuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => UnauthedAuthRouteRoute,
} as any)
const UnauthedAuthResetPasswordRoute =
  UnauthedAuthResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => UnauthedAuthRouteRoute,
  } as any)
const UnauthedAuthResetRoute = UnauthedAuthResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => UnauthedAuthRouteRoute,
} as any)
const UnauthedAuthLoginRoute = UnauthedAuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthedAuthRouteRoute,
} as any)
const AuthedRelationshipsSettingsRoute =
  AuthedRelationshipsSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedRelationshipsRouteRoute,
  } as any)
const AuthedRelationshipsDetailsRoute =
  AuthedRelationshipsDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthedRelationshipsRouteRoute,
  } as any)
const AuthedWorkspacesIdRouteRoute = AuthedWorkspacesIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedWorkspacesRouteRoute,
} as any)
const AuthedCartographiesIdRouteRoute =
  AuthedCartographiesIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthedCartographiesRouteRoute,
  } as any)
const AuthedWorkspacesIdIndexRoute = AuthedWorkspacesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedWorkspacesIdRouteRoute,
} as any)
const AuthedCartographiesIdIndexRoute =
  AuthedCartographiesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedCartographiesIdRouteRoute,
  } as any)
const AuthedWorkspacesIdSharingRoute =
  AuthedWorkspacesIdSharingRouteImport.update({
    id: '/sharing',
    path: '/sharing',
    getParentRoute: () => AuthedWorkspacesIdRouteRoute,
  } as any)
const AuthedWorkspacesIdSettingsRoute =
  AuthedWorkspacesIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedWorkspacesIdRouteRoute,
  } as any)
const AuthedWorkspacesIdNodesRoute = AuthedWorkspacesIdNodesRouteImport.update({
  id: '/nodes',
  path: '/nodes',
  getParentRoute: () => AuthedWorkspacesIdRouteRoute,
} as any)
const AuthedCartographiesIdClassicRoute =
  AuthedCartographiesIdClassicRouteImport.update({
    id: '/classic',
    path: '/classic',
    getParentRoute: () => AuthedCartographiesIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/public': typeof PublicRouteRouteWithChildren
  '/cartographies': typeof AuthedCartographiesRouteRouteWithChildren
  '/relationships': typeof AuthedRelationshipsRouteRouteWithChildren
  '/workspaces': typeof AuthedWorkspacesRouteRouteWithChildren
  '/auth': typeof UnauthedAuthRouteRouteWithChildren
  '/admin': typeof AuthedAdminRoute
  '/change-password': typeof AuthedChangePasswordRoute
  '/cartographies/$id': typeof AuthedCartographiesIdRouteRouteWithChildren
  '/workspaces/$id': typeof AuthedWorkspacesIdRouteRouteWithChildren
  '/relationships/details': typeof AuthedRelationshipsDetailsRoute
  '/relationships/settings': typeof AuthedRelationshipsSettingsRoute
  '/auth/login': typeof UnauthedAuthLoginRoute
  '/auth/reset': typeof UnauthedAuthResetRoute
  '/auth/reset-password': typeof UnauthedAuthResetPasswordRoute
  '/auth/signup': typeof UnauthedAuthSignupRoute
  '/public/cartographies/$id': typeof PublicCartographiesIdRoute
  '/cartographies/': typeof AuthedCartographiesIndexRoute
  '/workspaces/': typeof AuthedWorkspacesIndexRoute
  '/cartographies/$id/classic': typeof AuthedCartographiesIdClassicRoute
  '/workspaces/$id/nodes': typeof AuthedWorkspacesIdNodesRoute
  '/workspaces/$id/settings': typeof AuthedWorkspacesIdSettingsRoute
  '/workspaces/$id/sharing': typeof AuthedWorkspacesIdSharingRoute
  '/cartographies/$id/': typeof AuthedCartographiesIdIndexRoute
  '/workspaces/$id/': typeof AuthedWorkspacesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedIndexRoute
  '/public': typeof PublicRouteRouteWithChildren
  '/relationships': typeof AuthedRelationshipsRouteRouteWithChildren
  '/auth': typeof UnauthedAuthRouteRouteWithChildren
  '/admin': typeof AuthedAdminRoute
  '/change-password': typeof AuthedChangePasswordRoute
  '/relationships/details': typeof AuthedRelationshipsDetailsRoute
  '/relationships/settings': typeof AuthedRelationshipsSettingsRoute
  '/auth/login': typeof UnauthedAuthLoginRoute
  '/auth/reset': typeof UnauthedAuthResetRoute
  '/auth/reset-password': typeof UnauthedAuthResetPasswordRoute
  '/auth/signup': typeof UnauthedAuthSignupRoute
  '/public/cartographies/$id': typeof PublicCartographiesIdRoute
  '/cartographies': typeof AuthedCartographiesIndexRoute
  '/workspaces': typeof AuthedWorkspacesIndexRoute
  '/cartographies/$id/classic': typeof AuthedCartographiesIdClassicRoute
  '/workspaces/$id/nodes': typeof AuthedWorkspacesIdNodesRoute
  '/workspaces/$id/settings': typeof AuthedWorkspacesIdSettingsRoute
  '/workspaces/$id/sharing': typeof AuthedWorkspacesIdSharingRoute
  '/cartographies/$id': typeof AuthedCartographiesIdIndexRoute
  '/workspaces/$id': typeof AuthedWorkspacesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteRouteWithChildren
  '/_unauthed': typeof UnauthedRouteRouteWithChildren
  '/public': typeof PublicRouteRouteWithChildren
  '/_authed/cartographies': typeof AuthedCartographiesRouteRouteWithChildren
  '/_authed/relationships': typeof AuthedRelationshipsRouteRouteWithChildren
  '/_authed/workspaces': typeof AuthedWorkspacesRouteRouteWithChildren
  '/_unauthed/auth': typeof UnauthedAuthRouteRouteWithChildren
  '/_authed/admin': typeof AuthedAdminRoute
  '/_authed/change-password': typeof AuthedChangePasswordRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/cartographies/$id': typeof AuthedCartographiesIdRouteRouteWithChildren
  '/_authed/workspaces/$id': typeof AuthedWorkspacesIdRouteRouteWithChildren
  '/_authed/relationships/details': typeof AuthedRelationshipsDetailsRoute
  '/_authed/relationships/settings': typeof AuthedRelationshipsSettingsRoute
  '/_unauthed/auth/login': typeof UnauthedAuthLoginRoute
  '/_unauthed/auth/reset': typeof UnauthedAuthResetRoute
  '/_unauthed/auth/reset-password': typeof UnauthedAuthResetPasswordRoute
  '/_unauthed/auth/signup': typeof UnauthedAuthSignupRoute
  '/public/cartographies/$id': typeof PublicCartographiesIdRoute
  '/_authed/cartographies/': typeof AuthedCartographiesIndexRoute
  '/_authed/workspaces/': typeof AuthedWorkspacesIndexRoute
  '/_authed/cartographies/$id/classic': typeof AuthedCartographiesIdClassicRoute
  '/_authed/workspaces/$id/nodes': typeof AuthedWorkspacesIdNodesRoute
  '/_authed/workspaces/$id/settings': typeof AuthedWorkspacesIdSettingsRoute
  '/_authed/workspaces/$id/sharing': typeof AuthedWorkspacesIdSharingRoute
  '/_authed/cartographies/$id/': typeof AuthedCartographiesIdIndexRoute
  '/_authed/workspaces/$id/': typeof AuthedWorkspacesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/public'
    | '/cartographies'
    | '/relationships'
    | '/workspaces'
    | '/auth'
    | '/admin'
    | '/change-password'
    | '/cartographies/$id'
    | '/workspaces/$id'
    | '/relationships/details'
    | '/relationships/settings'
    | '/auth/login'
    | '/auth/reset'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/public/cartographies/$id'
    | '/cartographies/'
    | '/workspaces/'
    | '/cartographies/$id/classic'
    | '/workspaces/$id/nodes'
    | '/workspaces/$id/settings'
    | '/workspaces/$id/sharing'
    | '/cartographies/$id/'
    | '/workspaces/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/public'
    | '/relationships'
    | '/auth'
    | '/admin'
    | '/change-password'
    | '/relationships/details'
    | '/relationships/settings'
    | '/auth/login'
    | '/auth/reset'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/public/cartographies/$id'
    | '/cartographies'
    | '/workspaces'
    | '/cartographies/$id/classic'
    | '/workspaces/$id/nodes'
    | '/workspaces/$id/settings'
    | '/workspaces/$id/sharing'
    | '/cartographies/$id'
    | '/workspaces/$id'
  id:
    | '__root__'
    | '/_authed'
    | '/_unauthed'
    | '/public'
    | '/_authed/cartographies'
    | '/_authed/relationships'
    | '/_authed/workspaces'
    | '/_unauthed/auth'
    | '/_authed/admin'
    | '/_authed/change-password'
    | '/_authed/'
    | '/_authed/cartographies/$id'
    | '/_authed/workspaces/$id'
    | '/_authed/relationships/details'
    | '/_authed/relationships/settings'
    | '/_unauthed/auth/login'
    | '/_unauthed/auth/reset'
    | '/_unauthed/auth/reset-password'
    | '/_unauthed/auth/signup'
    | '/public/cartographies/$id'
    | '/_authed/cartographies/'
    | '/_authed/workspaces/'
    | '/_authed/cartographies/$id/classic'
    | '/_authed/workspaces/$id/nodes'
    | '/_authed/workspaces/$id/settings'
    | '/_authed/workspaces/$id/sharing'
    | '/_authed/cartographies/$id/'
    | '/_authed/workspaces/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren
  UnauthedRouteRoute: typeof UnauthedRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/public': {
      id: '/public'
      path: '/public'
      fullPath: '/public'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthed': {
      id: '/_unauthed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/change-password': {
      id: '/_authed/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthedChangePasswordRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_unauthed/auth': {
      id: '/_unauthed/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof UnauthedAuthRouteRouteImport
      parentRoute: typeof UnauthedRouteRoute
    }
    '/_authed/workspaces': {
      id: '/_authed/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof AuthedWorkspacesRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/relationships': {
      id: '/_authed/relationships'
      path: '/relationships'
      fullPath: '/relationships'
      preLoaderRoute: typeof AuthedRelationshipsRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/cartographies': {
      id: '/_authed/cartographies'
      path: '/cartographies'
      fullPath: '/cartographies'
      preLoaderRoute: typeof AuthedCartographiesRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/workspaces/': {
      id: '/_authed/workspaces/'
      path: '/'
      fullPath: '/workspaces/'
      preLoaderRoute: typeof AuthedWorkspacesIndexRouteImport
      parentRoute: typeof AuthedWorkspacesRouteRoute
    }
    '/_authed/cartographies/': {
      id: '/_authed/cartographies/'
      path: '/'
      fullPath: '/cartographies/'
      preLoaderRoute: typeof AuthedCartographiesIndexRouteImport
      parentRoute: typeof AuthedCartographiesRouteRoute
    }
    '/public/cartographies/$id': {
      id: '/public/cartographies/$id'
      path: '/cartographies/$id'
      fullPath: '/public/cartographies/$id'
      preLoaderRoute: typeof PublicCartographiesIdRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_unauthed/auth/signup': {
      id: '/_unauthed/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof UnauthedAuthSignupRouteImport
      parentRoute: typeof UnauthedAuthRouteRoute
    }
    '/_unauthed/auth/reset-password': {
      id: '/_unauthed/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof UnauthedAuthResetPasswordRouteImport
      parentRoute: typeof UnauthedAuthRouteRoute
    }
    '/_unauthed/auth/reset': {
      id: '/_unauthed/auth/reset'
      path: '/reset'
      fullPath: '/auth/reset'
      preLoaderRoute: typeof UnauthedAuthResetRouteImport
      parentRoute: typeof UnauthedAuthRouteRoute
    }
    '/_unauthed/auth/login': {
      id: '/_unauthed/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof UnauthedAuthLoginRouteImport
      parentRoute: typeof UnauthedAuthRouteRoute
    }
    '/_authed/relationships/settings': {
      id: '/_authed/relationships/settings'
      path: '/settings'
      fullPath: '/relationships/settings'
      preLoaderRoute: typeof AuthedRelationshipsSettingsRouteImport
      parentRoute: typeof AuthedRelationshipsRouteRoute
    }
    '/_authed/relationships/details': {
      id: '/_authed/relationships/details'
      path: '/details'
      fullPath: '/relationships/details'
      preLoaderRoute: typeof AuthedRelationshipsDetailsRouteImport
      parentRoute: typeof AuthedRelationshipsRouteRoute
    }
    '/_authed/workspaces/$id': {
      id: '/_authed/workspaces/$id'
      path: '/$id'
      fullPath: '/workspaces/$id'
      preLoaderRoute: typeof AuthedWorkspacesIdRouteRouteImport
      parentRoute: typeof AuthedWorkspacesRouteRoute
    }
    '/_authed/cartographies/$id': {
      id: '/_authed/cartographies/$id'
      path: '/$id'
      fullPath: '/cartographies/$id'
      preLoaderRoute: typeof AuthedCartographiesIdRouteRouteImport
      parentRoute: typeof AuthedCartographiesRouteRoute
    }
    '/_authed/workspaces/$id/': {
      id: '/_authed/workspaces/$id/'
      path: '/'
      fullPath: '/workspaces/$id/'
      preLoaderRoute: typeof AuthedWorkspacesIdIndexRouteImport
      parentRoute: typeof AuthedWorkspacesIdRouteRoute
    }
    '/_authed/cartographies/$id/': {
      id: '/_authed/cartographies/$id/'
      path: '/'
      fullPath: '/cartographies/$id/'
      preLoaderRoute: typeof AuthedCartographiesIdIndexRouteImport
      parentRoute: typeof AuthedCartographiesIdRouteRoute
    }
    '/_authed/workspaces/$id/sharing': {
      id: '/_authed/workspaces/$id/sharing'
      path: '/sharing'
      fullPath: '/workspaces/$id/sharing'
      preLoaderRoute: typeof AuthedWorkspacesIdSharingRouteImport
      parentRoute: typeof AuthedWorkspacesIdRouteRoute
    }
    '/_authed/workspaces/$id/settings': {
      id: '/_authed/workspaces/$id/settings'
      path: '/settings'
      fullPath: '/workspaces/$id/settings'
      preLoaderRoute: typeof AuthedWorkspacesIdSettingsRouteImport
      parentRoute: typeof AuthedWorkspacesIdRouteRoute
    }
    '/_authed/workspaces/$id/nodes': {
      id: '/_authed/workspaces/$id/nodes'
      path: '/nodes'
      fullPath: '/workspaces/$id/nodes'
      preLoaderRoute: typeof AuthedWorkspacesIdNodesRouteImport
      parentRoute: typeof AuthedWorkspacesIdRouteRoute
    }
    '/_authed/cartographies/$id/classic': {
      id: '/_authed/cartographies/$id/classic'
      path: '/classic'
      fullPath: '/cartographies/$id/classic'
      preLoaderRoute: typeof AuthedCartographiesIdClassicRouteImport
      parentRoute: typeof AuthedCartographiesIdRouteRoute
    }
  }
}

interface AuthedCartographiesIdRouteRouteChildren {
  AuthedCartographiesIdClassicRoute: typeof AuthedCartographiesIdClassicRoute
  AuthedCartographiesIdIndexRoute: typeof AuthedCartographiesIdIndexRoute
}

const AuthedCartographiesIdRouteRouteChildren: AuthedCartographiesIdRouteRouteChildren =
  {
    AuthedCartographiesIdClassicRoute: AuthedCartographiesIdClassicRoute,
    AuthedCartographiesIdIndexRoute: AuthedCartographiesIdIndexRoute,
  }

const AuthedCartographiesIdRouteRouteWithChildren =
  AuthedCartographiesIdRouteRoute._addFileChildren(
    AuthedCartographiesIdRouteRouteChildren,
  )

interface AuthedCartographiesRouteRouteChildren {
  AuthedCartographiesIdRouteRoute: typeof AuthedCartographiesIdRouteRouteWithChildren
  AuthedCartographiesIndexRoute: typeof AuthedCartographiesIndexRoute
}

const AuthedCartographiesRouteRouteChildren: AuthedCartographiesRouteRouteChildren =
  {
    AuthedCartographiesIdRouteRoute:
      AuthedCartographiesIdRouteRouteWithChildren,
    AuthedCartographiesIndexRoute: AuthedCartographiesIndexRoute,
  }

const AuthedCartographiesRouteRouteWithChildren =
  AuthedCartographiesRouteRoute._addFileChildren(
    AuthedCartographiesRouteRouteChildren,
  )

interface AuthedRelationshipsRouteRouteChildren {
  AuthedRelationshipsDetailsRoute: typeof AuthedRelationshipsDetailsRoute
  AuthedRelationshipsSettingsRoute: typeof AuthedRelationshipsSettingsRoute
}

const AuthedRelationshipsRouteRouteChildren: AuthedRelationshipsRouteRouteChildren =
  {
    AuthedRelationshipsDetailsRoute: AuthedRelationshipsDetailsRoute,
    AuthedRelationshipsSettingsRoute: AuthedRelationshipsSettingsRoute,
  }

const AuthedRelationshipsRouteRouteWithChildren =
  AuthedRelationshipsRouteRoute._addFileChildren(
    AuthedRelationshipsRouteRouteChildren,
  )

interface AuthedWorkspacesIdRouteRouteChildren {
  AuthedWorkspacesIdNodesRoute: typeof AuthedWorkspacesIdNodesRoute
  AuthedWorkspacesIdSettingsRoute: typeof AuthedWorkspacesIdSettingsRoute
  AuthedWorkspacesIdSharingRoute: typeof AuthedWorkspacesIdSharingRoute
  AuthedWorkspacesIdIndexRoute: typeof AuthedWorkspacesIdIndexRoute
}

const AuthedWorkspacesIdRouteRouteChildren: AuthedWorkspacesIdRouteRouteChildren =
  {
    AuthedWorkspacesIdNodesRoute: AuthedWorkspacesIdNodesRoute,
    AuthedWorkspacesIdSettingsRoute: AuthedWorkspacesIdSettingsRoute,
    AuthedWorkspacesIdSharingRoute: AuthedWorkspacesIdSharingRoute,
    AuthedWorkspacesIdIndexRoute: AuthedWorkspacesIdIndexRoute,
  }

const AuthedWorkspacesIdRouteRouteWithChildren =
  AuthedWorkspacesIdRouteRoute._addFileChildren(
    AuthedWorkspacesIdRouteRouteChildren,
  )

interface AuthedWorkspacesRouteRouteChildren {
  AuthedWorkspacesIdRouteRoute: typeof AuthedWorkspacesIdRouteRouteWithChildren
  AuthedWorkspacesIndexRoute: typeof AuthedWorkspacesIndexRoute
}

const AuthedWorkspacesRouteRouteChildren: AuthedWorkspacesRouteRouteChildren = {
  AuthedWorkspacesIdRouteRoute: AuthedWorkspacesIdRouteRouteWithChildren,
  AuthedWorkspacesIndexRoute: AuthedWorkspacesIndexRoute,
}

const AuthedWorkspacesRouteRouteWithChildren =
  AuthedWorkspacesRouteRoute._addFileChildren(
    AuthedWorkspacesRouteRouteChildren,
  )

interface AuthedRouteRouteChildren {
  AuthedCartographiesRouteRoute: typeof AuthedCartographiesRouteRouteWithChildren
  AuthedRelationshipsRouteRoute: typeof AuthedRelationshipsRouteRouteWithChildren
  AuthedWorkspacesRouteRoute: typeof AuthedWorkspacesRouteRouteWithChildren
  AuthedAdminRoute: typeof AuthedAdminRoute
  AuthedChangePasswordRoute: typeof AuthedChangePasswordRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedCartographiesRouteRoute: AuthedCartographiesRouteRouteWithChildren,
  AuthedRelationshipsRouteRoute: AuthedRelationshipsRouteRouteWithChildren,
  AuthedWorkspacesRouteRoute: AuthedWorkspacesRouteRouteWithChildren,
  AuthedAdminRoute: AuthedAdminRoute,
  AuthedChangePasswordRoute: AuthedChangePasswordRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
)

interface UnauthedAuthRouteRouteChildren {
  UnauthedAuthLoginRoute: typeof UnauthedAuthLoginRoute
  UnauthedAuthResetRoute: typeof UnauthedAuthResetRoute
  UnauthedAuthResetPasswordRoute: typeof UnauthedAuthResetPasswordRoute
  UnauthedAuthSignupRoute: typeof UnauthedAuthSignupRoute
}

const UnauthedAuthRouteRouteChildren: UnauthedAuthRouteRouteChildren = {
  UnauthedAuthLoginRoute: UnauthedAuthLoginRoute,
  UnauthedAuthResetRoute: UnauthedAuthResetRoute,
  UnauthedAuthResetPasswordRoute: UnauthedAuthResetPasswordRoute,
  UnauthedAuthSignupRoute: UnauthedAuthSignupRoute,
}

const UnauthedAuthRouteRouteWithChildren =
  UnauthedAuthRouteRoute._addFileChildren(UnauthedAuthRouteRouteChildren)

interface UnauthedRouteRouteChildren {
  UnauthedAuthRouteRoute: typeof UnauthedAuthRouteRouteWithChildren
}

const UnauthedRouteRouteChildren: UnauthedRouteRouteChildren = {
  UnauthedAuthRouteRoute: UnauthedAuthRouteRouteWithChildren,
}

const UnauthedRouteRouteWithChildren = UnauthedRouteRoute._addFileChildren(
  UnauthedRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicCartographiesIdRoute: typeof PublicCartographiesIdRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicCartographiesIdRoute: PublicCartographiesIdRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  UnauthedRouteRoute: UnauthedRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
